import { Controller } from "@hotwired/stimulus";

// Saisie libre avec suggestions (<datalist>), où seule une entrée de la liste est acceptée : le texte tapé
// n'est pas envoyé, le code de l'entrée reconnue part dans le champ caché. Un texte qui ne correspond à
// aucune entrée porte une erreur de validation ; un champ vidé envoie un code vide. Comme
// compliance_country_combobox_controller.js, pour une liste longue (les vendeurs d'un étage) qu'une seule
// <datalist> sert à toutes les lignes.
export default class extends Controller {
  static targets = ["input", "code"];
  static values = { invalid: String };

  connect() {
    this.#validate();
  }

  sync() {
    this.codeTarget.value = this.#exactMatch()?.code ?? "";
    this.#validate();
  }

  // En sortie de champ : un début de libellé sans ambiguïté vaut choix.
  settle() {
    const match = this.#exactMatch() ?? this.#uniquePrefixMatch();
    if (match) {
      this.inputTarget.value = match.label;
      this.codeTarget.value = match.code;
    }
    this.#validate();
  }

  #validate() {
    const invalid = this.inputTarget.value.trim() !== "" && this.codeTarget.value === "";
    this.inputTarget.setCustomValidity(invalid ? this.invalidValue : "");
  }

  #exactMatch() {
    const typed = normalize(this.inputTarget.value);
    if (!typed) return null;

    return this.#entries().find((entry) => entry.key === typed) ?? null;
  }

  #uniquePrefixMatch() {
    const typed = normalize(this.inputTarget.value);
    if (!typed) return null;

    const matches = this.#entries().filter((entry) => entry.key.startsWith(typed));
    return matches.length === 1 ? matches[0] : null;
  }

  #entries() {
    if (!this.entries) {
      const list = document.getElementById(this.inputTarget.getAttribute("list"));
      this.entries = Array.from(list?.options ?? []).map((option) => ({
        label: option.value,
        code: option.dataset.code,
        key: normalize(option.value),
      }));
    }
    return this.entries;
  }
}

// Insensible à la casse et aux accents.
function normalize(value) {
  return value.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().trim();
}
